import React, { useEffect, useState } from "react";
import { Question, Option } from "../types";

interface QuestionCardProps {
  question: Question;
  onSelectOption: (option: Option) => void;
  selectedOptionText: string | null;
  disabled?: boolean;
}

// ...existing code...

const shuffleArray = (array: Option[]) => {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

const QuestionCard: React.FC<QuestionCardProps> = ({
  question,
  onSelectOption,
  selectedOptionText,
  disabled = false,
}) => {
  const [shuffledOptions, setShuffledOptions] = useState<Option[]>([]);

  useEffect(() => {
    setShuffledOptions(shuffleArray(question.options));
  }, [question]);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl mx-auto">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        {question.text}
      </h2>

      <div className="space-y-3">
        {shuffledOptions.map((option) => (
          <button
            className={`w-full text-left p-4 rounded-md border-2 transition-all duration-200 ${
              selectedOptionText === option.text
                ? "border-orange-500 bg-orange-50"
                : "border-gray-200 hover:border-orange-300"
            } ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
            onClick={() => onSelectOption(option)}
            disabled={disabled}
          >
            <p className="text-gray-800">{option.text}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuestionCard;
